import { render, staticRenderFns } from "./InlineIcon.vue?vue&type=template&id=6e9465c8&"
import script from "./InlineIcon.vue?vue&type=script&lang=js&"
export * from "./InlineIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports